<template>
  <div id="app" :class="{ 'app--printmode': printMode }">
    <router-view />
    <canvas ref="app__canvas-confetti" class="app__canvas-confetti" />
  </div>
</template>

<script>
import { Bus } from "./main";
const confetti = require("canvas-confetti");

export default {
  name: "App",
  data() {
    return {
      lang: "en",
      printMode: false,
    };
  },
  mounted() {
    this.myConfetti = confetti.create(this.$refs["app__canvas-confetti"], {
      resize: true,
      useWorker: true,
    });

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    this.printMode = params.printmode;

    Bus.$on("download-cv", () => {
      let counter = 0;
      const settings = {
        particleCount: 75,
        spread: 90,
        colors: ["#B93E36", "#f4f5f0", "#1a201c"],
        startVelocity: 75,
      };

      const confetti = this.myConfetti;

      (function frame() {
        confetti({ ...settings, angle: 45, origin: { x: 0, y: 1 } });
        confetti({ ...settings, angle: 135, origin: { x: 1, y: 1 } });
        counter++;
        counter < 10 && setTimeout(frame, 60);
      })();
    });
  },
};
</script>

<style>
@import "./assets/styles.css";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #d0d0d0;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  min-height: 100vh;
  padding: 30mm 0;
}

#app.app--printmode {
  padding: 0;
  width: 210mm;
  min-height: 297mm;
}

.app__canvas-confetti {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
}

@media screen and (max-width: 240mm) {
  #app {
    padding: 10mm 0;
  }
}

@media print {
  #app {
    background: white;
    padding: 0;
  }
}
</style>
